import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

const Header = () => {
  const { lang, setLang, t } = useLanguage();

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/50 border-b border-white/10"
      data-testid="main-header"
    >
      <div className="flex items-center justify-between px-5 md:px-10 h-[72px]">
        <a href="#top" className="flex items-center gap-3 group" data-testid="header-logo">
          <img src="/assets/paq-logo-light.webp" alt="PAQ" className="h-7 w-auto transition-transform duration-500 group-hover:scale-105" />
        </a>

        <nav className="hidden lg:flex items-center gap-8 font-mono text-xs tracking-widest text-white/60" data-testid="main-nav">
          <a href="#tecnologia" className="hover:text-thermal transition-colors duration-300" data-testid="nav-tech">{t.nav.tech.toUpperCase()}</a>
          <a href="#numeri" className="hover:text-thermal transition-colors duration-300" data-testid="nav-numbers">{t.nav.numbers.toUpperCase()}</a>
          <a href="#manifesto" className="hover:text-thermal transition-colors duration-300" data-testid="nav-manifesto">{t.nav.manifesto.toUpperCase()}</a>
          <a href="#contatti" className="hover:text-thermal transition-colors duration-300" data-testid="nav-contact">{t.nav.contact.toUpperCase()}</a>
        </nav>

        <div className="flex items-center gap-4">
          <div className="font-mono text-xs tracking-widest border border-white/15 flex" data-testid="lang-toggle">
            <button
              onClick={() => setLang("it")}
              className={`px-3 py-2 transition-colors duration-300 ${lang === "it" ? "bg-white text-black" : "text-white/50 hover:text-white"}`}
              data-testid="lang-it-btn"
            >
              IT
            </button>
            <button
              onClick={() => setLang("en")}
              className={`px-3 py-2 transition-colors duration-300 ${lang === "en" ? "bg-white text-black" : "text-white/50 hover:text-white"}`}
              data-testid="lang-en-btn"
            >
              EN
            </button>
          </div>
          <a
            href="#contatti"
            className="hidden sm:block bg-thermal text-black font-mono text-xs tracking-widest px-5 py-2.5 hover:bg-white transition-colors duration-300"
            data-testid="header-cta"
          >
            {t.nav.cta.toUpperCase()}
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
